import type { SxProps, Theme } from '@mui/material'
import { Stack, Typography } from '@mui/material'
import React from 'react'

interface IconTextProps {
  icon: React.ReactNode
  label: string
  onClick?: () => void
  color?: string
  fontSize?: string
  fontWeight?: number | string
  sx?: SxProps<Theme>
  iconStyle?: React.CSSProperties
  spacing?: number
}

const IconText: React.FC<IconTextProps> = ({
  icon,
  label,
  onClick,
  color = 'rgba(144, 202, 249, 1)',
  fontSize = '13px',
  fontWeight = 500,
  sx = {},
  iconStyle = { color: 'rgba(144, 202, 249, 1)', fontSize: 18 },
  spacing = 1,
}) => {
  let renderedIcon

  if (typeof icon === 'string') {
    renderedIcon = <img src={icon} alt="" style={{ ...iconStyle }} />
  } else if (React.isValidElement(icon)) {
    renderedIcon = React.cloneElement(icon, { sx: iconStyle })
  } else {
    renderedIcon = icon
  }

  return (
    <Stack
      direction="row"
      spacing={spacing}
      alignItems="center"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        ...sx,
      }}
    >
      {renderedIcon}
      <Typography
        sx={{
          color,
          fontWeight,
          fontSize,
          display: 'flex',
          alignItems: 'center',
          lineHeight: '22px',
        }}
      >
        {label}
      </Typography>
    </Stack>
  )
}

export default IconText
